module.exports = __webpack_public_path__ + "enterprise-ux-research.2m2I0cAR.svg";